<template>
  <q-dialog v-model="shown">
    <q-card style="width: 400px;">
      <q-card-section class="row items-center q-mx-xs">
        <div class="text-h6">
          Select Roles
        </div>
        <q-space />
        <q-btn
          v-close-popup
          icon="close"
          flat
          round
          dense
        />
      </q-card-section>
      <q-card-section>
        <div
          class="relative-position"
          style="min-height: 200px; max-height: 75vh; overflow: auto;"
        >
          <q-list
            bordered
            separator
          >
            <q-item
              v-for="role in roles.data"
              :key="role.id"
              clickable
              @click.stop="user.toggleRole(role)"
            >
              <q-item-section avatar>
                <q-checkbox
                  class="no-pointer-events"
                  :model-value="!!$_.find(user.roles.data, { id: role.id })"
                />
              </q-item-section>
              <q-item-section>
                <q-item-label>
                  {{ role.name }}
                </q-item-label>
              </q-item-section>
            </q-item>
          </q-list>
          <q-inner-loading :showing="roles.loading" />
        </div>
      </q-card-section>
    </q-card>
  </q-dialog>
</template>

<script>
import User from 'src/models/user/User'

export default {
  name: 'SelectUserRolesDialog',
  props: {
    modelValue: {
      type: Boolean,
      required: false
    },
    user: {
      type: User,
      required: true
    }
  },
  configuration: ['roles'],
  emits: ['update:model-value'],
  data () {
    return {
      shown: false
    }
  },
  watch: {
    shown () {
      this.$emit('update:model-value', this.shown)
    }
  },
  methods: {
    show () {
      this.shown = true
    }
  }
}
</script>
